import {MultiCurrencyPriceFragment} from '../../../../gql/graphql';
import {ModelContext} from '../../../../types/checkoutApp.types';
import {PriceModel} from '../Price.model';
import {mapNullToUndefined} from '../../../utils/mapperHelper.utils';

export class TaxModel {
  public name?: string;
  public amount: PriceModel;
  public exemptAmount: PriceModel;

  constructor(params: TaxModel) {
    this.name = params.name;
    this.amount = params.amount;
    this.exemptAmount = params.exemptAmount;
  }

  public static fromCheckoutV1({
    taxAmount,
    modelContext,
    taxName,
    totalExempt,
  }: {
    taxAmount?: MultiCurrencyPriceFragment | null;
    totalExempt?: MultiCurrencyPriceFragment | null;
    modelContext: ModelContext;
    taxName?: string | null;
  }) {
    return new TaxModel({
      name: mapNullToUndefined(taxName),
      amount: PriceModel.fromCheckoutV1(taxAmount, modelContext),
      exemptAmount: PriceModel.fromCheckoutV1(totalExempt, modelContext),
    });
  }
}
